<template>
    <div class="v-flex" v-if="filter">
        <v-menu
            :close-on-content-click="false"
            bottom
            offset-y
            nudge-bottom="5"
        >
            <template v-slot:activator="{ on, attrs }">
                <a
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="nav-icon toolbar-button" :class="filter ? 'primary--text' : 'red--text'">{{ filter ? 'mdi-filter' : 'mdi-filter-outline' }} </v-icon>
                </a>
            </template>

            <div class="white pa-2 pb-3">
                <v-row dense>
                    <v-col class="v-flex">
                        <v-checkbox
                            v-if    = "filter"
                            v-model = "filter.onlyIdleIncidents"
                            class   = "mt-0"
                            :ripple = "false"
                            @click  = "onChange"
                            hide-details
                        >
                            <template v-slot:label>
                                <span class="filter-label"><v-icon size="20" style="width: 30px">mdi-flash</v-icon>Ereignisse mit Stillstand</span>
                            </template>
                        </v-checkbox>
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col class="v-flex">
                        <v-checkbox
                            v-if    = "filter"
                            v-model = "filter.onlyOpenIncidents"
                            class   = "mt-0"
                            :ripple = "false"
                            @click  = "onChange"
                            hide-details
                        >
                            <template v-slot:label>
                                <span class="filter-label"><v-icon size="20" style="width: 30px">mdi-account-edit</v-icon>Nur offene Ereignisse</span>
                            </template>
                        </v-checkbox>
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col class="v-flex">
                        <v-checkbox
                            v-if    = "filter"
                            v-model = "filter.onlyMyCustomers"
                            class   = "mt-0"
                            :ripple = "false"
                            @click  = "onChange"
                            hide-details
                        >
                            <template v-slot:label>
                                <span class="filter-label"><v-icon size="20" style="width: 30px">mdi-account-multiple</v-icon>Nur meine Kunden</span>
                            </template>
                        </v-checkbox>
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col class="v-flex">
                        <v-checkbox
                            v-if    = "filter"
                            v-model = "filter.onlyMyIncidents"
                            class   = "mt-0"
                            :ripple = "false"
                            @click  = "onChange"
                            hide-details
                        >
                            <template v-slot:label>
                                <span class="filter-label"><v-icon size="20" style="width: 30px">mdi-account</v-icon>Nur meine Ereignisse</span>
                            </template>
                        </v-checkbox>
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col class="v-flex">
                        <v-checkbox
                            v-if    = "filter"
                            v-model = "filter.ignoreDeleted"
                            class   = "mt-0"
                            :ripple = "false"
                            @click  = "onChange"
                            hide-details
                        >
                            <template v-slot:label>
                                <span class="filter-label"><v-icon size="20" style="width: 30px">mdi-delete</v-icon>Gelöschte Ereignisse ausblenden</span>
                            </template>
                        </v-checkbox>
                    </v-col>
                </v-row>
            </div>
        </v-menu>
        <div v-if="changed">
            <c-toolbar-button
                icon="mdi-filter-off"
                color="primary"
                size="24"
                @click = "onClear"
            />
        </div>
        <div class="v-flex lm-border ml-1" style="width: 130px;" v-if="filter">
            <div v-if="filter.onlyIdle" class="pl-2" style="margin-top: 1px;">
                <v-icon size="22">mdi-flash</v-icon>
            </div>
            <div v-if="filter.onlyOpen" class="pl-2">
                <v-icon size="22">mdi-account-edit</v-icon>
            </div>
            <div v-if="filter.onlyMyCustomers" class="pl-2">
                <v-icon size="22">mdi-account-multiple</v-icon>
            </div>
            <div v-if="!filter.onlyMyCustomers" class="pl-2">
                <v-icon size="22" color="primary">mdi-all-inclusive</v-icon>
            </div>
            <div v-if="filter.onlyMe" class="pl-2">
                <v-icon size="22">mdi-account</v-icon>
            </div>
            <div v-if="filter.ignoreDeleted && restoredata" class="pl-2">
                <v-icon size="22">mdi-delete</v-icon>
            </div>
        </div>
    </div>
</template>

<script>

import CToolbarButton from "@/modules/core/components/utils/CToolbarButton";

export default {
    name: "CAppIncidentFilter",

    components: {
        CToolbarButton
    },

    data: () => ({
        defaultFilter: {
            onlyIdleIncidents: false,
            onlyMyCustomers  : true,
            onlyOpenIncidents: false,
            onlyMyIncidents  : false,
            ignoreDeleted    : true
        },
    }),

    computed: {
        changed () {
            return this.filter.onlyIdleIncidents !== this.defaultFilter.onlyIdleIncidents
                || this.filter.onlyMyCustomers !== this.defaultFilter.onlyMyCustomers
                || this.filter.onlyOpenIncidents !== this.defaultFilter.onlyOpenIncidents
                || this.filter.onlyMyIncidents !== this.defaultFilter.onlyMyIncidents
                || this.filter.ignoreDeleted !== this.defaultFilter.ignoreDeleted
                ;
        },
        filter () {
            return this.$store.getters.preferences["userFilter"];
        },

        preferences () {
            return this.$store.getters.preferences;
        },

        restoredata () {
            return this.preferences['restoredata'];
        }
    },

    mounted() {
    },

    methods: {
        onClear () {
            this.filter.onlyMyCustomers = this.onlyMyCustomers;
            this.filter.onlyIdleIncidents = this.onlyIdleIncidents;
            this.filter.onlyMyIncidents = this.onlyMyIncidents;
            this.filter.onlyOpenIncidents = this.onlyOpenIncidents;
            this.filter.ignoreDeleted = this.ignoreDeleted;
            this.onChange();
        },

        onChange () {
            this.$store.dispatch("setIncidentFilter", this.filter).then(() => {
                this.$emit("change", this.filter);
            })
        }
    }
}
</script>

<style scoped>
.filter-label {
    font-size: 15px;
    margin-top: 2px;
    margin-left: -5px;
}
</style>